import React, { useEffect, useState } from "react";
import "../Destination/DestinationPost.css";
import destination1 from "../Destination/tour1.webp";
import destination2 from "../Destination/tour2.webp";

const DestinationPost = () => {
  const images = [destination1, destination2];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="destination-post">
      <div
        className="slider-image"
        style={{ backgroundImage: `url(${images[current]})` }}
      >
        <div className="overlayd"></div>
        <div className="destination-text">
          <h1>Explore World Wonders</h1>
          <p>
            Journey to breathtaking destinations that will leave you in awe of
            our planet's beauty.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DestinationPost;
